/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Scope_Point_3Inputs */

const en_svc_n8n_scope_point_3 = /** @type {(inputs: Svc_N8n_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repair and clean-up of existing n8n workflows`)
};

const lv_svc_n8n_scope_point_3 = /** @type {(inputs: Svc_N8n_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esošo n8n darba plūsmu labošana un sakārtošana`)
};

/**
* | output |
* | --- |
* | "Repair and clean-up of existing n8n workflows" |
*
* @param {Svc_N8n_Scope_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_scope_point_3 = /** @type {((inputs?: Svc_N8n_Scope_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Scope_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_scope_point_3(inputs)
	return en_svc_n8n_scope_point_3(inputs)
});